<div class="flex justify-content-between px-3">
  <div>
    <!-- <img src="assets/images/footer-left-image.png" alt="Sara Plus Logo" class="footer-left"> -->
  </div>
  @if (isAttProvider) {
    <div>
      <img src="assets/images/At&tdealer.svg" alt="AT&T Dealer Logo" class="footer-middle">
    </div>
  }
  <div>
    <img src="assets/images/logo/SecureDataSaraplusLogo.svg" alt="Sara Plus Logo" class="footer-right">
  </div>
</div>